// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title-price-widget {
  display: flex;
}
@media (max-width: 768px) {
  .title-price-widget {
    flex-wrap: wrap;
  }
}

.price-input > label {
  margin-bottom: 0.75rem;
}
.price-input input {
  border-radius: 0 6px 6px 0 !important;
}
.price-input select {
  width: 140px;
  border-right: 0;
  border-radius: 6px 0 0 6px;
}
.price-input select.variant-price {
  width: 100%;
  margin-bottom: 1rem;
  border-right: 1px solid var(--black1);
  border-radius: 6px;
  background: var(--white);
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/screens/products/product/screens/components/price/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AACE;EAHF;IAII,eAAA;EAEF;AACF;;AAEE;EACE,sBAAA;AACJ;AAEE;EACE,qCAAA;AAAJ;AAGE;EACE,YAAA;EACA,eAAA;EACA,0BAAA;AADJ;AAII;EACE,WAAA;EACA,mBAAA;EACA,qCAAA;EACA,kBAAA;EACA,wBAAA;AAFN","sourcesContent":[".title-price-widget {\n  display: flex;\n\n  @media (max-width: 768px) {\n    flex-wrap: wrap;\n  }\n}\n\n.price-input {\n  & > label {\n    margin-bottom: .75rem;\n  }\n\n  input {\n    border-radius: 0 6px 6px 0 !important;\n  }\n\n  select {\n    width: 140px;\n    border-right: 0;\n    border-radius: 6px 0 0 6px;\n\n\n    &.variant-price {\n      width: 100%;\n      margin-bottom: 1rem;\n      border-right: 1px solid var(--black1);\n      border-radius: 6px;\n      background: var(--white);\n    }\n  }\n\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
